import React, { memo } from "react";
import "./CatalogsSection.css";

/** Velikosti datotek v public/katalogi (posodobi ob zamenjavi PDF) */
const FILE_SIZES = {
  slo: 8615957,
  hrv: 1737054,
};

function formatPdfSize(bytes) {
  const mb = bytes / (1024 * 1024);
  const s = mb >= 10 ? mb.toFixed(0) : mb.toFixed(1);
  return `PDF · ${s.replace(".", ",")} MB`;
}

function PdfDocumentIcon() {
  return (
    <svg
      className="catalogs-pdf-icon"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M28 4H12a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V16l-12-12z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M28 4v12h12"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M14 28h20M14 34h14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg
      className="catalogs-btn-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <polyline
        points="7 10 12 15 17 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

const catalogs = [
  {
    title: "Katalog SLO",
    langLabel: "SLOVENŠČINA",
    href: "/katalogi/katalog-slo.pdf",
    download: "katalog-slo.pdf",
    lang: "sl",
    sizeBytes: FILE_SIZES.slo,
  },
  {
    title: "Katalog HRV",
    langLabel: "HRVATSKI",
    href: "/katalogi/katalog-hrv.pdf",
    download: "katalog-hrv.pdf",
    lang: "hr",
    sizeBytes: FILE_SIZES.hrv,
  },
];

const CatalogsSection = memo(() => (
  <section className="catalogs-section" id="katalogi" aria-labelledby="catalogs-heading">
    <div className="catalogs-section-inner">
      <header className="catalogs-section-header">
        <h2 id="catalogs-heading">Katalogi</h2>
        <p className="catalogs-section-subtitle">Prenesite naše kataloge</p>
      </header>
      <div className="catalogs-section-grid">
        {catalogs.map((item, index) => (
          <React.Fragment key={item.title}>
            {index > 0 && (
              <div className="catalogs-divider" role="separator" aria-hidden="true" />
            )}
            <article className="catalogs-card">
              <div className="catalogs-card-icon-wrap">
                <PdfDocumentIcon />
              </div>
              <div className="catalogs-card-body">
                <p className="catalogs-card-lang">{item.langLabel}</p>
                <h3 className="catalogs-card-title">{item.title}</h3>
                <p className="catalogs-card-meta">{formatPdfSize(item.sizeBytes)}</p>
                <a
                  href={item.href}
                  download={item.download}
                  className="catalogs-card-btn"
                  lang={item.lang}
                >
                  <DownloadIcon />
                  Prenesi PDF
                </a>
              </div>
            </article>
          </React.Fragment>
        ))}
      </div>
    </div>
  </section>
));

CatalogsSection.displayName = "CatalogsSection";

export default CatalogsSection;
